export const introStyle = {
  display: 'grid',
  gap: 10,
};

export const filterGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
  gap: 8,
  alignItems: 'end',
};

export const exportGridStyle = {
  display: 'grid',
  gridTemplateColumns: '90px minmax(150px, 1fr) minmax(120px, 0.8fr) minmax(120px, 0.8fr)',
  gap: 8,
  alignItems: 'end',
};

export const sectionLabelStyle = {
  display: 'grid',
  gap: 4,
  color: 'var(--text)',
  fontSize: 12,
  fontWeight: 700,
};

export const inputStyle = {
  minHeight: 36,
  width: '100%',
  border: '1px solid var(--border)',
  borderRadius: 6,
  background: 'var(--bg)',
  color: 'var(--text)',
  padding: '6px 9px',
  fontSize: 13,
  lineHeight: 1.3,
  boxSizing: 'border-box',
};

export const buttonStyle = {
  minHeight: 36,
  border: '1px solid var(--border)',
  borderRadius: 6,
  background: 'var(--bg-card)',
  color: 'var(--text)',
  padding: '6px 12px',
  cursor: 'pointer',
  fontWeight: 700,
  whiteSpace: 'nowrap',
};

export const primaryButtonStyle = {
  ...buttonStyle,
  background: 'var(--accent-700, #2563eb)',
  color: '#fff',
  borderColor: 'var(--accent-700, #2563eb)',
};

export const summaryGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  gap: 8,
};

export const summaryCardStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-subtle)',
  padding: 10,
  display: 'grid',
  gap: 3,
};

export const mutedTextStyle = {
  color: 'var(--text-muted)',
  fontSize: 12,
};

export const strongTextStyle = {
  color: 'var(--text)',
  fontSize: 16,
  fontWeight: 800,
};

export const tableWrapStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  overflow: 'auto',
  maxHeight: '48vh',
};

export const tableStyle = {
  width: '100%',
  minWidth: 860,
  borderCollapse: 'collapse',
  fontSize: 12,
};

export const thStyle = {
  position: 'sticky',
  top: 0,
  background: 'var(--bg)',
  color: 'var(--text-muted)',
  borderBottom: '1px solid var(--border)',
  padding: '8px 10px',
  textAlign: 'left',
  whiteSpace: 'nowrap',
  zIndex: 1,
};

export const tdStyle = {
  borderTop: '1px solid var(--border)',
  padding: '7px 10px',
  color: 'var(--text)',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
};

export const amountTdStyle = {
  ...tdStyle,
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
};

export const statusChipStyle = (confirmed) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 72,
  minHeight: 26,
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 800,
  color: confirmed ? '#065f46' : '#92400e',
  background: confirmed ? '#d1fae5' : '#fef3c7',
});

export const memoInputStyle = {
  ...inputStyle,
  minHeight: 32,
  minWidth: 150,
  padding: '5px 8px',
};

export const footerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  flexWrap: 'wrap',
};

export const mobileCss = `
  @media (max-width: 720px) {
    .card-deposit-filter-grid,
    .card-deposit-export-grid,
    .card-deposit-summary-grid {
      grid-template-columns: 1fr !important;
    }
    .card-deposit-footer {
      align-items: stretch !important;
    }
    .card-deposit-footer button {
      width: 100%;
    }
  }
`;
